import { Button } from '@/components/ui/button';
import { Pencil, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface BaseMapListItemProps {
  name: string;
  type: string;
  url: string;
  onEdit: () => void;
  onRemove: () => void;
}

export function BaseMapListItem({ name, type, url, onEdit, onRemove }: BaseMapListItemProps) {
  const { t } = useTranslation('components');
  return (
    <div className='flex items-center justify-between rounded-md border p-2'>
      <div className='min-w-0 flex-1'>
        <div className='flex items-baseline gap-1'>
          <span className='text-sm font-medium'>{name}</span>
          <span className='text-xs text-muted-foreground font-medium'>{t(`baseMapTypes.${type}`, { defaultValue: type })}</span>
        </div>
        <div className='text-xs text-muted-foreground line-clamp-1'>{url}</div>
      </div>
      <div className='flex shrink-0'>
        <Button type='button' variant='ghost' size='icon' onClick={onEdit}>
          <Pencil className='size-3.5' />
        </Button>
        <Button
          type='button'
          variant='ghost'
          size='icon'
          className='text-red-500 hover:text-red-600'
          onClick={onRemove}>
          <Trash2 className='size-3.5' />
        </Button>
      </div>
    </div>
  );
}
